import type { BoxProps } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'

export const SubMenu = ({ children, ...rest }: BoxProps) => {
  return (
    <Box
      as="ul"
      sx={{
        p: 2,
        width: 'max-content',
        position: 'absolute',
        top: '100%',
        left: 0,
        bg: 'white',
        borderRadius: 'md',
        boxShadow: 'md',
        listStyle: 'none',
        zIndex: 'subMenu',
      }}
      {...rest}
    >
      {children}
    </Box>
  )
}